import React, {useEffect, useState} from "react";
import Filter from './Filter'
import {findUnit} from "../../utils";



const FilterInput = ({name, onValueChange, marks, unit, label, isOpen, currentValue}) => {
  let currentMin;
  let currentMax;

  const parsedUnit = findUnit(marks) || unit;
  const min = parseFloat(marks[0].value);
  const max = parseFloat(marks[marks.length - 1].value);

  if (currentValue) {
    currentMin = parseFloat(currentValue[0]);
    currentMax = parseFloat(currentValue[1]);
  } else {
    currentMin = min;
    currentMax = max;
  }

  const [values, setValues] = useState({
    min: currentMin ? currentMin : '',
    max: currentMax ? currentMax : '',
    hasChanged : false
  });

  useEffect(() => {
    setValues({min: currentMin, max: currentMax});
  }, [currentValue]);


  function onChangeHandler(event)
  {
    setValues({...values, [event.target.name]: event.target.value, hasChanged: true});
  }

  function onBlurHandler(event)
  {
    if (!event.target.value) {
      setValues({...values, [event.target.name]: 0, hasChanged: true});
    }
    if (values.hasChanged) {
      onValueChange(name, [`${values.min || min} ${parsedUnit}`, `${values.max || max} ${parsedUnit}`]);
      values.hasChanged = false;
    }
  }

  return (
    <Filter label={label} isOpen={isOpen}>
      <div className="product-finder-aside__fieldset">
        <div className="product-finder-aside__spread">
          <div className="product-finder-aside__cell" data-unit={unit}>
            <input
              value={values.min}
              name="min"
              type="number"
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              onKeyDown={(e) => e.key === 'Enter' && onBlurHandler(e)}
              className="product-finder-aside__textbox"/>
          </div>
          <div className="product-finder-aside__cell" data-unit={unit}>
            <input
              value={values.max}
              name="max"
              type="number"
              onChange={onChangeHandler}
              onBlur={onBlurHandler}
              onKeyDown={(e) => e.key === 'Enter' && onBlurHandler(e)}
              className="product-finder-aside__textbox"/>
          </div>
        </div>
      </div>
    </Filter>
  );
};

export default FilterInput;
